module.exports = __webpack_public_path__ + "static/media/cancer-home.7d071bd2.jpg";